import { render } from "./upData-name.vue?vue&type=template&id=296a1cd9&scoped=true"
import script from "./upData-name.vue?vue&type=script&lang=js"
export * from "./upData-name.vue?vue&type=script&lang=js"

import "./upData-name.vue?vue&type=style&index=0&id=296a1cd9&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296a1cd9"]])

export default __exports__